<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/insular-header-pt.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/madeira-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para a Madeira</p>
          <p class="body-1 justify-text">
            <b> Cobertura insular:</b> Serviço de entrega prevista no dia útil seguinte ao da sua
            recolha (via aérea), com peso máximo por volume de 20 kg. E em 2 dias úteis (via
            marítima), com peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/acores-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para os Açores</p>
          <p class="body-1 justify-text">
            <b> Cobertura insular:</b> Serviço de entrega prevista no dia útil seguinte ao da sua
            recolha (via aérea) com peso máximo por volume de 5 kg. E em 2 dias úteis (via marítima),
            com peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttcanarias-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para as Canárias</p>
          <p class="body-1 justify-text">
            <b> Cobertura insular:</b> Serviço de entrega prevista desde 2 dias úteis após a sua recolha. Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttbaleares-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para as Baleares</p>
          <p class="body-1 justify-text">
            <b> Cobertura insular:</b> Serviço de entrega prevista desde 1 dia útil após a sua recolha, e desde 2 dias úteis. Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>

      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttotherdest-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios para outros Destinos</p>
          <p class="body-1 justify-text">
            <b> Cobertura insular:</b> Serviço de entrega prevista desde 2 dias úteis após a sua recolha. Peso máximo por volume de 30 kg.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2025-pt/Footer'

export default {
  name: 'InsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularIntro')
  },
}
</script>
